import React from "react";
import { Clock, Users } from "lucide-react";

const PromotionBanner = () => {
  return (
    <section className="bg-dark py-10">
      <div className="container mx-auto px-4">
        <div style={{backgroundColor: '#1f2e2d'}} className="backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-gold/30">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-6 text-gold">Promocje Specjalne</h2>
          
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div className="flex flex-col space-y-6">
              <div style={{backgroundColor: '#e3d4b3'}} className="backdrop-blur-md p-6 rounded-xl border border-gold/20 transform transition-transform hover:scale-105">
                <div className="flex items-center mb-4">
                  <Clock className="text-dark mr-3" size={28} />
                  <h3 className="text-2xl font-semibold text-dark">Happy Hours</h3>
                </div>
                <p className="text-lg text-dark">Skorzystaj z -15% zniżki na wszystkie masaże w godzinach 10:00-14:00 od poniedziałku do piątku!</p>
              </div>
              
              <div style={{backgroundColor: '#e3d4b3'}} className="backdrop-blur-md p-6 rounded-xl border border-gold/20 transform transition-transform hover:scale-105">
                <div className="flex items-center mb-4">
                  <Users className="text-dark mr-3" size={28} />
                  <h3 className="text-2xl font-semibold text-dark">Rabat dla par</h3>
                </div>
                <p className="text-lg text-dark">-10% zniżki na masaż dla par! Zarezerwujcie wspólny relaks i zafundujcie sobie wyjątkowe chwile razem.</p>
              </div>
            </div>
            
            <div className="flex justify-center">
              <div className="relative">
                <img 
                  src="/photos/promocje-specjalne.png"
                  alt="Vouchery promocyjne ChaBa Thai"
                  className="rounded-lg shadow-lg max-w-full h-auto"
                />
                <img 
                  src="/photos/promocje-specjalne-2.png"
                  alt="Voucher ChaBa Thai w misce z kwiatami"
                  className="absolute -bottom-8 -right-8 w-32 h-32 md:w-48 md:h-48 object-cover rounded-full border-4 border-gold/30 shadow-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromotionBanner;
